'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var toast = require('pobble-components/dist/toast');

var utils = require('pobble-components/dist/utils');

var authHelpers = require('pobble-components/dist/auth-helpers');

var cookies = require('pobble-components/dist/cookies');

var handler = function handler(e) {
  var ref = utils.getErrorInfo(e).ref;
  var errorsMap = {
    e0044: "Please use PNG or JPEG format for the images",
    e0045: "File is too large, please select a file less than 10mb",
    e0048: "File is too large, please select a file less than 22mb",
    e0049: "File is too large, please select a file less than 56mb",
    e0051: "File is too large, please select a smaller file",
    def: "\n      Oops, something went wrong.\n      If this continues to happen\n      please contact hello@pobble.com.\n      Ref: ".concat(ref || 'unknown', "\n    ")
  };

  if (e.response && e.response.status === 401) {
    cookies.JWT_EXPIRED.set(true);
    authHelpers.unsetToken();
    authHelpers.redirectToAuth({
      redirectBack: true
    });
  } else {
    toast.toast.error(errorsMap[ref] || errorsMap.def, {
      autoClose: 6000
    });
  }
};

exports.errorHandler = handler;